function radioFeatures(){

  $('.radio-features input').on('change', function() {
    const $this = $(this);
    const radioValue = $this.next('label').text();
    $this.closest('.form-row').find('.option_name .selected').text(radioValue);
  })

}

export default radioFeatures();



// WEBPACK FOOTER //
// ../markup/assets/js/radio-features.js